import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../notification/notification.service';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Game } from '../../../../backend/src/games/entities/game.entity';
import { EditGameComponent } from './edit-game/edit-game.component';

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrl: './games.component.scss'
})
export class GamesComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name','prefix','url','edit'];
  dataSource: MatTableDataSource<any>;
  fetching: boolean = false;
  selectedGame: Game | {} = {};
  pageSize = 20;
  pageIndex = 0;
  totalGames = 0;
  readonly pageSizeOptions = [20, 50, 100];

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private notificationService: NotificationService
  ) { 
    this.dataSource = new MatTableDataSource<Game>();
  }

  ngOnInit(): void {
    this.fetchGames();
  }

  fetchGames() {
    this.fetching = true;
    this.http.get<{ items: Game[]; total: number; page: number; pageSize: number }>(`games?${this.getCurrentQueryFilter()}`).subscribe({
      next: (response) => {
        this.totalGames = response?.total || 0;
        this.dataSource.data = response?.items || [];
        if (!this.dataSource.data.length && this.totalGames > 0 && this.pageIndex > 0) {
          this.pageIndex = Math.max(Math.ceil(this.totalGames / this.pageSize) - 1, 0);
          this.fetchGames();
          return;
        }
        this.fetching = false;
      },
      error: (e) => {
        this.notificationService.show(`Hiba a játékok betöltése során! Részletek: ${e.message}`, 'danger');
        this.fetching = false;
      },
    });
  }

  getCurrentQueryFilter(): string {
    const params = new URLSearchParams();
    params.set('page', `${this.pageIndex}`);
    params.set('page_size', `${this.pageSize}`);
    return params.toString();
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchGames();
  }

  addNewGame() {
    this.selectedGame = {};
    this.openGameEditor();
  }

  editGame(game: Game) {
    this.selectedGame = game;
    this.openGameEditor();
  }

  openGameEditor() {
    const dialogRef = this.dialog.open(EditGameComponent, {
      data: {game: this.selectedGame},
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result === true) {
        this.fetchGames();
      }
    });
  }

}
